import React from 'react'
import { MdDone } from 'react-icons/md'

const Logout = () => {
    return (
        <div className="d-flex h-100 align-items-center">
            <div className='p-2 w-100 h-25'>
                <div className='d-flex justify-content-center'>
                    <span className="text-success pt-2 pb-1 pl-2 pr-2 mr-2 rounded-circle border border-success rounded-lg">
                        <MdDone></MdDone>
                    </span>
                    <h3>You signed out of your account</h3>
                </div>
                <div className='d-flex justify-content-center'>
                    <label>it's a good idea to close browser windows</label>
                </div>
                <div className='d-flex justify-content-center'>
                    <a className="btn btn-primary text-white" href="/">Back to site</a>
                </div>
            </div>
        </div>
    )
}

export default Logout;
